<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>3</span></p>
<p class="normal">“BASCOM wouldn’t murder anybody,” observed Jake as the skycar climbed up through the hazy morning. “No, let’s amend that. He wouldn’t murder anybody in such a clumsy, unsubtle way. Hell, there wouldn’t be clues, wouldn’t be sectapes of his doing the deed.”</p>
<p class="indent">“<i>Sí</i>, exactly,” agreed Sid Gomez, who was in the pilot seat. “However, your old <i>compañero</i> Lieutenant Drexler believes otherwise. Which is why our esteemed <i>jefe</i> is residing in the hoosegow at the moment.”</p>
<p class="indent">“It’s got to be a frame-up.”</p>
<p class="indent">Gomez, who was roughly ten years younger than his partner, nodded. “A very thorough one, though,” he pointed out. “From what I’ve been able to glean, the security camera stuff looks <i>and</i> tests absolutely authentic. Far as the minions of the law can tell, anyway.”</p>
<p class="indent">“But that security footage can’t be legit.” Slouching in his seat, Jake absently massaged the knuckles of his left hand.</p>
<p class="indent">“Proving that is only one of several jobs facing the Cosmos Detective Agency.”</p>
<p class="indent">“Now, about some more background on this emergency meeting you’re dragging me to?”</p>
<p class="indent">“A strategy session, <i>amigo</i>. We have to start working on this whole mess even while Bascom is still in the clink.”</p>
<p class="indent">“You haven’t mentioned,” said Jake, “who’s running the agency while Bascom’s away.”</p>
<p class="indent">Stroking his bushy mustache, Gomez squinted out at the brightening morning. “I was hoping I could get you safely delivered to work without that particular name crossing my rose-petal lips.”</p>
<p class="indent">Jake sat up. “Bascom put Roy Anselmo in as acting chief, huh?”</p>
<p class="indent">“Well, <i>sí</i>. I know you think Roy is a pompous, egotistic putz, yet he—”</p>
<p class="indent">“You,” reminded Jake, “share my opinion of the guy, Sidney.”</p>
<p class="indent">“Okay, we’re unanimous as to his being a pompous putz. But the <i>hombre</i>, even you must admit, is an efficient operative and a damn good administrator.”</p>
<p class="indent">“Maybe.”</p>
<p class="indent">“You weren’t expecting the <i>jefe</i> to put you in charge, were you?”</p>
<p class="indent">“Jesus, no.” Jake stiffened further, shaking his head and frowning. “But I can sure as hell think of a lot of people at the Cosmos Agency I’d rather have bossing me. I can even draw up a list of lesser assholes I’d prefer.”</p>
<p class="indent">“Well, <i>amigo</i>, we must repress our true feelings and concentrate on saving Bascom’s ass,” urged his partner. “So, <i>por favor</i>, control your dislike for Roy when we arrive at this get-together.”</p>
<p class="indent">“I’ll behave,” promised Jake with minimal conviction.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter003.vue?6880b5ef